import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

interface Notification {
  id: string
  progress: number
  status: 'success' | 'error' | 'uploading'
  read: boolean
  createdAt: string
  // Uploads set these; background jobs (Table export) set title/message instead.
  totalFiles?: number
  totalSize?: number
  title?: string
  message?: string
}

const fakeData = [
  {
    id: '1',
    progress: 0,
    status: 'uploading',
    read: false,
    createdAt: new Date().toISOString(),
    totalFiles: 1,
    totalSize: 215500000000, // 215.5 GB
  },
  {
    id: '2',
    progress: 52,
    status: 'uploading',
    read: false,
    createdAt: new Date().toISOString(),
    totalFiles: 1,
    totalSize: 215500000000,
  },
  {
    id: '3',
    progress: 100,
    status: 'success',
    read: false,
    createdAt: new Date().toISOString(),
    totalFiles: 1,
    totalSize: 215500000000,
  },
  {
    id: '4',
    progress: 45,
    status: 'error',
    read: false,
    createdAt: new Date().toISOString(),
    totalFiles: 1,
    totalSize: 215500000000,
  },
]

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Notification[]>([])

  const add = (noti: Notification) => {
    notifications.value.push(noti)
  }

  const remove = (id: string) => {
    notifications.value = notifications.value.filter((noti) => noti.id !== id)
  }

  const get = (id: string) => {
    return notifications.value.find((noti) => noti.id === id)
  }

  const clear = () => {
    notifications.value = []
  }

  const update = (id: string, noti: Partial<Notification>) => {
    notifications.value = notifications.value.map((n) => {
      if (n.id === id) {
        if (n.status !== 'uploading') {
          return n
        }
        return { ...n, ...noti } as Notification
      }
      return n
    })
  }

  const markAsRead = (id: string) => {
    notifications.value = notifications.value.map((n) => (n.id === id ? { ...n, read: true } : n))
  }

  const countUnread = computed(() => {
    return notifications.value.filter((noti) => !noti.read).length
  })

  return { notifications, add, remove, get, clear, update, markAsRead, countUnread }
})
